import React, { Component } from "react"

class UserSvg extends Component {

    render = () => {

        return (
            <svg width="91" height="91" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 73C6 58.0883 18.0883 46 33 46C33 46 39.3811 53.6125 45 54C51.2821 54.4332 59 46 59 46C73.9117 46 86 58.0883 86 73V79C86 84.5228 81.5228 89 76 89H16C10.4772 89 6 84.5228 6 79V73Z" fill="white" />
                <path d="M66 22C66 33.0457 57.0457 47.5 46 47.5C34.9543 47.5 26 33.0457 26 22C26 10.9543 34.9543 2 46 2C57.0457 2 66 10.9543 66 22Z" fill="white" />
            </svg>
        )
    }

}

export default UserSvg